module.exports = __webpack_public_path__ + "img/waxlight-desktop.18747133.jpg";